<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker
              :label="$t('solicitacoesRelatorios.startDate')"
              v-model="dti"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker
              :label="$t('solicitacoesRelatorios.endDate')"
              v-model="dtf"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="2" align="center" style="align-self: center;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  :loading="loading"
                  :disabled="!formValidado"
                  @click="fetchItems"
                  style="margin-bottom: 5px;"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="setDefaultFilters"
                  style="margin-left: 10px; margin-bottom: 5px;"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.newConsult') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-card class="mt-4">
      <v-card-title class="subtitle-1">
        {{ $t('solicitacoesRelatorios.title') }}
      </v-card-title>
      <v-divider />
      <SolicitacoesRelatoriosList :items="items" :loading="loading" />
    </v-card>
  </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import SolicitacoesRelatoriosList from '@/components/SolicitacoesRelatoriosList.vue';

function formatDateTimeLocal(date) {
  const pad = (n) => String(n).padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    ` ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  );
}

export default {
  name: 'SolicitacoesRelatorios',
  components: { SolicitacoesRelatoriosList },
  data() {
    return {
      formValidado: true,
      loading: false,
      items: [],
      dti: null,
      dtf: null,
      timeProps: { format: '24hr', useSeconds: true },
      textFieldProps: { prependIcon: '', rules: [(v) => !!v || ''] },
    };
  },
  mounted() {
    this.setDefaultFilters();
    this.fetchItems();
    EventBus.$on('scheduler-download-enqueued', this.fetchItems);
    EventBus.$on('system-log-export-updated', this.fetchItems);
    EventBus.$on('scheduler-download-updated', this.fetchItems);
  },
  beforeDestroy() {
    EventBus.$off('scheduler-download-enqueued', this.fetchItems);
    EventBus.$off('system-log-export-updated', this.fetchItems);
    EventBus.$off('scheduler-download-updated', this.fetchItems);
  },
  methods: {
    setDefaultFilters() {
      const today = new Date();
      const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
      const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
      this.dti = start;
      this.dtf = end;
    },
    toApiDate(value) {
      if (!value) return null;
      if (value instanceof Date) {
        return formatDateTimeLocal(value);
      }
      if (typeof value === 'string') {
        return value;
      }
      return null;
    },
    fetchItems() {
      const dti = this.toApiDate(this.dti);
      const dtf = this.toApiDate(this.dtf);
      if (!dti || !dtf) {
        return;
      }
      this.loading = true;
      apiController.request(apiController.endpoints.schedulerGetSolicitacoesrelatorios, {
        data: { dti, dtf },
        silent: true,
        onSuccess: (response) => {
          this.items = (response.data && response.data.solicitacoes) || [];
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
  },
};
</script>
